import React from 'react'
import ContentBox from '@shared/ContentBox'
import SalaryCardOrderForm from './feature/SalaryCardOrderForm'
import { tabsItems } from './constants/tabsItems.constant'
import { useTranslation } from 'react-i18next'

function CreateCardOrder() {
  const { t } = useTranslation()
  return (
    <ContentBox
      title={t('orders.newOrderscards')}
      activeKey="item-2"
      items={tabsItems()}
    >
      <SalaryCardOrderForm />
    </ContentBox>
  )
}

export default CreateCardOrder
